import {useNavigate} from "react-router-dom";
import React, {useContext, useEffect, useRef, useState} from "react";
import {Card, CardContent, Chip} from "@mui/material";
import MDBox from "../../components/MDBox";
import CustomerHeader from "../common/CustomerHeader";
import Footer from "../Footer";
import CustomerPageLayout from "../Layout/CustomerPageLayout";
import Grid from "@mui/material/Grid";
import MDTypography from "../../components/MDTypography";
import {exportIcalendar, formatDateTime, formatDateTimeTz, getPreferenceValue, prettyDateTime} from "../common/Utils";
import MDButton from "../../components/MDButton";
import {
  getMyReservations,
  getMyVisits,
  saveInventoryEventCancellation,
  saveSpecialRequest
} from "../common/api/PortalCustomerApi";
import {UserContext} from "../../lib/UserProvider";
import {AppContext} from "../../lib/AppContext";
import ReservationSpecialRequest from "./ReservationSpecialRequest";
import Menu from "@mui/material/Menu";
import NotificationItem from "../Items/NotificationItem";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import Confirm from "../common/Confirm";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import CancelIcon from "@mui/icons-material/Cancel";
import PersonIcon from "@mui/icons-material/Person";
import {CompanyContext} from "../../lib/CompanyProvider";
import Meta from "../common/Meta";

export default function CustomerVisits(props) {
  const navigate = useNavigate();
  const [userContext, setUserContext] = useContext(UserContext);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);

  const [visits, setVisits] = useState();
  const [reservations, setReservations] = useState();
  const [visitsReady, setVisitsReady] = useState(false);
  const [reservationsReady, setReservationsReady] = useState(false);
  const [featureFlagIcalExport, setFeatureFlagIcalExport] = useState(false);

  useEffect(() => {
    if (!userContext?.sessionUser?.guid) {
      return;
    }
    getMyVisitsFn();
    getUpcomingReservationsFn();
  }, [userContext?.sessionUser?.guid]);

  const getMyVisitsFn = async () => {
    let result = await getMyVisits();
    setVisits(result);
    setVisitsReady(true);
  }

  const getUpcomingReservationsFn = async () => {
    let result = await getMyReservations();
    setReservations(result);
    setReservationsReady(true);
  }

  const [saving, setSaving] = useState(false);
  const [context, setContext] = useContext(AppContext);
  const [showReservationSpecialRequest, setShowReservationSpecialRequest] = useState(false);
  const [reservationSpecialRequest, setReservationSpecialRequest] = useState(null);
  const handleCloseSpecialRequest = () => {
    setReservationSpecialRequest(null);
    setShowReservationSpecialRequest(false);
  }

  const handleSaveReservationRequest = async (reservation) => {

    setSaving(true);

    let result = await saveSpecialRequest(reservation);

    setSaving(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setShowReservationSpecialRequest(false);
      setReservationSpecialRequest(null);

      let _context = {...context};
      _context.toast = {
        message: 'Special Request Saved',
      }
      setContext({..._context});
      getUpcomingReservationsFn();
    }
  }

  const addSpecialRequest = (reservation) => {
    setReservationSpecialRequest(reservation);
    setShowReservationSpecialRequest(true);
  }

  const [confirmation, setConfirmation] = useState(null);
  const [confirmCancel, setConfirmCancel] = useState(false);

  const myRefs = useRef([]);
  const [renderIndex, setRenderIndex] = useState(1);
  const handleConfirmCancel = (inventoryEvent) => {
    let confirmation = {
      title: 'Event Cancellation',
      message: 'Confirm ' + inventoryEvent.eventName + ' cancellation.',
      entity: inventoryEvent
    }

    if (inventoryEvent.selfCancelDisabled) {
      confirmation = {
        title: 'Event Cancellation',
        message: inventoryEvent.eventName + ' cancellation unavailable.',
        entity: inventoryEvent
      }
    }

    setConfirmation(confirmation);
    setConfirmCancel(true);
  }
  const refHandler = (index) => {
    myRefs.current[index].visible = !!!myRefs.current[index].visible;
    setRenderIndex(renderIndex + 1);
  };

  const ReservationItemActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'inventory-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <span variant="contained" {...bindTrigger(popupState)}>
           <MDButton
             variant="outlined"
             color="secondary"
             size="small"
             circular
             iconOnly
           >
            <MoreHorizIcon/>
          </MDButton>
          </span>
          <Menu {...bindMenu(popupState)}>
            {item.specialRequest && <NotificationItem onClick={(e) => {
              addSpecialRequest(item)
            }} icon={<PersonAddIcon/>}
                                                      title="Special Request"/>}
            <NotificationItem
              disabled={item?.selfCancelDisabled}
              onClick={(e) => {
                handleConfirmCancel(item)
              }} icon={<CancelIcon/>} title={'Cancel' + (!!(item?.selfCancelDisabled) ? ' unavailable' : '')}/>

          </Menu>
        </>
      )}
    </PopupState>);
  }

  const handleCloseConfirm = () => {
    setConfirmation(null);
    setConfirmCancel(false);
  };

  const handleEventCancel = (inventoryEvent) => {
    if (inventoryEvent.selfCancelDisabled) {
      setConfirmCancel(false);
      setConfirmation(null);
      return;
    }

    saveInventoryEventCancellation(inventoryEvent).then(result => {
      setConfirmCancel(false);
      setConfirmation(null);
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        getUpcomingReservationsFn();
      }
    });
  }

  return (
    <CustomerPageLayout>
      <Meta pageTitle={'Customer Visits'}/>
      <CustomerHeader props={props}/>
      <MDBox m={1} p={1}>
        <h1>
          {companyContext?.company?.preferences && getPreferenceValue(companyContext?.company?.preferences, 'menu_item_visits', 'My Visits')}
          <MDButton
            color="info"
            size="small"
            style={{
              float: 'right'
            }}
            onClick={(e) => {
              navigate('/cx/my-profile');
            }}>
            <PersonIcon/>&nbsp;My Profile
          </MDButton>
        </h1>
        {visitsReady && <div>
          <MDBox className={'mb-4'}>
            <Grid container cols={1} spacing={3} direction="row">
              <Grid item xs={12} sm={12}>

                <MDBox m={1}>
                  <MDBox>
                    <div style={{
                      display: 'block',
                      width: '100%',
                    }}>
                      <MDTypography variant="h5" fontWeight="light" className="my-3">
                        Upcoming Reservations
                        {featureFlagIcalExport && reservationsReady && reservations?.length > 0 && <MDButton
                          size={"small"}
                          style={{
                            float: 'right'
                          }}
                          className={'pull-right mr-2'} color="primary"
                          onClick={() => {
                            let _events = [];
                            console.dir(reservations);
                            reservations.forEach((e, idx) => {
                              _events.push({
                                start: e.eventDate,
                                end: e.eventDate,
                                title: e.eventName,
                              })
                            });
                            exportIcalendar(_events, "Upcoming Reservations");
                          }}>Export</MDButton>}
                      </MDTypography>
                    </div>

                    <ul className={'list-group'}>
                      {reservationsReady && reservations?.length === 0 && <li className={'list-group-item'}>
                        <center>No upcoming reservations</center>
                      </li>}
                      {reservationsReady && reservations?.length > 0 && reservations?.sort((a, b) => new Date(a.eventDate).getTime() - new Date(b.eventDate).getTime())
                        .map((item, index) => {
                            return (
                              <li
                                className={'list-group-item'}
                                key={index}>
                              <span style={{float: 'right'}}>
                                <ReservationItemActions item={item}/>
                               </span>

                                <MDTypography variant="h6" style={{display: 'inline-block'}}>
                                  {item?.eventName}
                                </MDTypography>
                                <MDTypography variant="p" className="d-block">
                                  {item?.eventTypeName}
                                </MDTypography>
                                <MDTypography variant="p" className="d-block">
                                  <span>Event Date: {prettyDateTime(item.eventDate)}</span>
                                </MDTypography>

                                <MDTypography variant="p" className="d-block">
                                  <span>Guest: {item.attendee.firstName + ' ' + item.attendee.lastName}</span>
                                </MDTypography>
                                {item.eventGuests?.length > 0 &&
                                  <div>
                                    <span><b>Additional Event Guests</b> </span>
                                    <ul className={'list-group'}>

                                      {item?.eventGuests.sort((b, a) => a.lastName.localeCompare(b.lastName)).map((g, idx)=> {
                                        return (
                                          <li key={idx} className={'list-group-item'}>
                                            {g.firstName} {g.lastName}
                                          </li>
                                        )
                                        })
                                      }
                                    </ul>
                                  </div>
                                }
                                {item?.reservationPurchaseItems?.length > 0 && <p>
                                  <span>Items: </span>
                                  {item?.reservationPurchaseItems.sort((b, a) => a.sortOrder - b.sortOrder).map((pi, idx) => {
                                    return (
                                      <span key={idx}>{idx === 0 ? '' : ', '}{pi.name}</span>
                                    )
                                  })
                                  }
                                </p>}

                                {item.specialRequestInput && <>
                                  <MDBox>
                                    <MDTypography variant="p" color="text" fontWeight="bold">
                                      Special Request:&nbsp;
                                    </MDTypography>
                                    <MDTypography variant="p" color="text" fontWeight="regular">
                                      {item.specialRequestInput}
                                    </MDTypography>
                                  </MDBox>
                                </>}

                                <span>
                                      {item?.reservationStatus?.name && <Chip
                                        label={item.reservationStatus.name}
                                        variant="outlined"
                                        color="secondary"/>}
                                    </span>

                              </li>
                            )
                          }
                        )}
                    </ul>

                    <MDTypography variant="h5" fontWeight="light" className="my-3">
                      Visit History
                    </MDTypography>
                    <ul className={'list-group'}>
                      {visitsReady && visits?.length > 0 && visits?.sort((a, b) => new Date(a.visitDate).getTime() - new Date(b.visitDate).getTime())
                        .map((item, index) => {
                            return (
                              <li
                                className={'list-group-item'}
                                key={index}>
                                <MDTypography variant="h6" fontWeight={"bold"}>
                                  {item?.event?.inventory?.name}
                                </MDTypography>
                                <MDTypography variant="p" className="d-block">
                                  {item?.event?.inventory?.eventType?.name}
                                </MDTypography>
                                <MDTypography variant="p" className="d-block">
                                  {companyContext?.timeZone &&
                                    <span>Event Date: {formatDateTimeTz(item.visitDate, 'dddd, MMMM Do, YYYY h:mm a', companyContext?.timeZone)}</span>
                                  }
                                </MDTypography>
                              </li>
                            )
                          }
                        )}
                    </ul>

                  </MDBox>
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
        </div>
        }
      </MDBox>

      <Footer/>

      {confirmCancel && <Confirm confirmation={confirmation}
                                 show={confirmCancel}
                                 saving={saving}
                                 handleConfirm={handleEventCancel}
                                 handleClose={handleCloseConfirm}/>}

      {
        showReservationSpecialRequest && <ReservationSpecialRequest
          reservation={reservationSpecialRequest}
          show={showReservationSpecialRequest}
          saving={saving}
          handleSave={handleSaveReservationRequest}
          handleClose={handleCloseSpecialRequest}/>
      }

    </CustomerPageLayout>
  )
}